<template>
  <path
    d="M11.99 2.00024C6.47 2.00024 2 6.48024 2 12.0002C2 17.5202 6.47 22.0002 11.99 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 11.99 2.00024ZM15.22 17.3902L12 15.4502L8.78 17.3902C8.4 17.6202 7.93 17.2802 8.03 16.8502L8.88 13.1902L6.05 10.7402C5.72 10.4502 5.9 9.90024 6.34 9.86024L10.08 9.54024L11.54 6.09024C11.71 5.68024 12.29 5.68024 12.46 6.09024L13.92 9.53024L17.66 9.85024C18.1 9.89024 18.28 10.4402 17.94 10.7302L15.11 13.1802L15.96 16.8502C16.06 17.2802 15.6 17.6202 15.22 17.3902Z"
  />
</template>
